// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1FEyA","left":"InfoRow_left__32XLp"};